import React from 'react';
import { AnalysisSummaryHeader } from './analysis/AnalysisSummaryHeader';
import { AnalysisAlerts } from './analysis/AnalysisAlerts';
import { ComparisonTable } from './analysis/ComparisonTable';
import { SavingsRow } from './analysis/SavingsRow';
import { AnalysisFooter } from './analysis/AnalysisFooter';

/**
 * Risultato completo dell'analisi: header, alerts, confronto, risparmio, footer.
 * Wrappato in analysisRef per il rendering PDF.
 *
 * @param {Object} props
 * @param {React.RefObject} props.analysisRef
 * @param {Object} props.analysis
 * @param {boolean} props.isHistorical
 * @param {boolean} props.downloading
 * @param {Function} props.onDownloadPdf
 * @param {string} props.manualCte
 * @param {Function} props.onManualCteChange
 * @param {Array} props.availableCtes
 * @param {boolean} props.updatingCte
 * @param {Function} props.onUpdateCte
 */
export const AnalysisResult = ({
  analysisRef, analysis, isHistorical,
  downloading, onDownloadPdf,
  manualCte, onManualCteChange, availableCtes, updatingCte, onUpdateCte,
  onUpdateAnnualConsumption,
  onEditExtracted,
  isFinalized, finalizing, onFinalize,
}) => {
  // Inline edit (nome cliente + aliquota IVA) attivo solo in modalità volatile.
  const canEdit = !isHistorical && !isFinalized;
  const isGas = analysis.competitor_data?.service_type === 'gas';
  // Toggle mostra/nascondi il codice CTE nella tabella (persistito solo in-memory: default = mostra)
  const [showCteInPdf, setShowCteInPdf] = React.useState(true);
  return (
    <div
      ref={analysisRef}
      className="bg-white"
      data-testid={`analysis-result-${isGas ? 'gas' : 'energia'}`}
    >
      <AnalysisSummaryHeader
        analysis={analysis}
        isHistorical={isHistorical}
        downloading={downloading}
        onDownloadPdf={onDownloadPdf}
        manualCte={manualCte}
        onManualCteChange={onManualCteChange}
        availableCtes={availableCtes}
        updatingCte={updatingCte}
        onUpdateCte={onUpdateCte}
        isFinalized={isFinalized}
        finalizing={finalizing}
        onFinalize={onFinalize}
        showCteInPdf={showCteInPdf}
        onToggleCteInPdf={() => setShowCteInPdf((v) => !v)}
      />

      <AnalysisAlerts competitorData={analysis.competitor_data} validation={analysis.validation} />

      <ComparisonTable analysis={analysis} onEditExtracted={canEdit ? onEditExtracted : null} showCte={showCteInPdf} />

      <SavingsRow
        analysis={analysis}
        onUpdateAnnualConsumption={canEdit ? onUpdateAnnualConsumption : null}
      />

      <AnalysisFooter analysis={analysis} />
    </div>
  );
};
